import React, { useEffect } from 'react';
import Fade from '@mui/material/Fade';
import Icon from '../../../components/icon/Icon';
import PropTypes from 'prop-types';
import { styled, css } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Modal as BaseModal } from '@mui/base/Modal';
import { useTranslation } from 'react-i18next';
import LANG, { getLangWithKey } from '../../../lang';
import { AlertType, AlertConfig } from './alertEnums';
import useDarkMode from '../../../hooks/useDarkMode';

export const Ralert = ({
	msgtypeloadalert,
	loadalert,
	closemodel,
	confirmbt,
	minutes,
	seconds,
	stage,
}) => {
	const { i18n, t } = useTranslation();
	const currentLang = getLangWithKey(i18n.language);
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const matches = useMediaQuery('(max-width:600px)');

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	let type = AlertType.WARNING;
	const lowerType = msgtypeloadalert?.toLowerCase();
	if (lowerType === 'error') type = AlertType.ERROR;
	else if (lowerType === 'success') type = AlertType.SUCCESS;

	const { color, icon } = AlertConfig[type];

	let stageMessage = '';
	if (stage === 'extend') {
		stageMessage = t('Do you need more time to complete your booking?');
	} else if (stage === 'final') {
		stageMessage = t('Please process your checkout within 10 min.');
	}

	return (
		<Modal
			aria-labelledby='transition-modal-title'
			aria-describedby='transition-modal-description'
			open={loadalert}
			onClose={(_, reason) => reason === 'backdropClick' && closemodel()}
			closeAfterTransition
			slots={{ backdrop: StyledBackdrop }}>
			<Fade in={loadalert}>
				<ModalContent>
					<div
						style={{
							height: matches ? null : '300px',
							width: matches ? '300px' : '450px',
							flexDirection: 'column',
							position: 'relative',
							backgroundColor: darkModeStatus ? '#242632' : '#ececec',
							color: darkModeStatus ? 'white' : null,
						}}>
						<div
							style={{
								height: '80%',
								alignContent: 'center',
								paddingBottom: matches && '10px',
								paddingTop: matches && '10px',
							}}>
							<center>
								<div
									className='mt-2'
									style={{
										height: matches ? '50px' : '70px',
										width: matches ? '50px' : '70px',
										borderRadius: '100px',
										border:
											color === 'danger'
												? '4px solid rgb(253, 83, 97)'
												: color === 'success'
												? '4px solid #3aba6f'
												: '4px solid #ffc107',
									}}>
									<Icon
										icon={icon}
										color={color}
										size='5x'
										forceFamily='bootstrap'
									/>
								</div>
							</center>

							<div
								className='mt-4'
								style={{
									fontSize: !matches && '22px',
									fontWeight: 'bold',
									display: 'flex',
									width: '100%',
									alignItems: 'center',
									flexDirection: 'column',
									justifyContent: 'space-between',
									textShadow: '0px 3px 12px 0px rgb(0 0 0 / 0.4)',
								}}>
								{currentLang === LANG.EN
									? msgtypeloadalert.toUpperCase()
									: t(msgtypeloadalert)}
							</div>

							<div
								className='mt-1'
								style={{
									fontSize: !matches && '15px',
									display: 'flex',
									width: '100%',
									alignItems: 'center',
									flexDirection: 'column',
									justifyContent: 'space-between',
									textShadow: '0px 3px 12px 0px rgb(0 0 0 / 0.4)',
									paddingInline: '6px',
								}}>
								{msgtypeloadalert === t('Session Timeout Warning') && (
									<>
										{stage === 'extend' ? (
											<>
												{t('Your booking session will expire in')}{' '}
												<strong>
													{minutes !== undefined
														? minutes < 10
															? `0${minutes}`
															: minutes
														: '00'}
													:
													{seconds !== undefined
														? seconds < 10
															? `0${seconds}`
															: seconds
														: '00'}
												</strong>{' '}
												{t('due to inactivity')}. {stageMessage}
											</>
										) : stage === 'checkout' ? (
											<>{t('Please process your checkout within 10 min.')}</>
										) : (
											<>
												{t('Your booking session will expire in')}{' '}
												<strong>
													{minutes !== undefined
														? minutes < 10
															? `0${minutes}`
															: minutes
														: '00'}
													:
													{seconds !== undefined
														? seconds < 10
															? `0${seconds}`
															: seconds
														: '00'}
												</strong>{' '}
												{t('due to inactivity')}. {stageMessage}
											</>
										)}
									</>
								)}
							</div>
						</div>

						<div
							className='row'
							style={{
								height: '20%',
								alignContent: 'center',
								backgroundColor:
									color === 'danger'
										? 'rgb(253, 83, 97)'
										: color === 'success'
										? '#3aba6f'
										: '#ffc107',
							}}>
							<div
								className='col text-center h-100 d-flex align-items-center justify-content-center'
								style={{
									backgroundColor:
										stage !== 'checkout' ? 'rgb(230, 230, 230)' : undefined,
								}}>
								<button
									type='button'
									className='btn btn'
									onClick={closemodel}
									style={{
										height: '100%',
										width: '100%',
										fontSize: !matches && '18px',
										paddingTop: matches && '10px',
										paddingBottom: matches && '10px',
										boxShadow: 'none',
										color:
											(color !== 'warning' || stage === 'checkout') &&
											'white',
									}}>
									{stage === 'checkout' ? t('OK') : t('NO')}
								</button>
							</div>
							{stage === 'extend' && (
								<div className='col d-flex align-items-center justify-content-center'>
									<button
										type='button'
										className='btn btn'
										onClick={confirmbt}
										style={{
											height: '100%',
											width: '100%',
											fontSize: !matches && '18px',
											paddingTop: matches && '10px',
											paddingBottom: matches && '10px',
											boxShadow: 'none',
											color: 'white',
										}}>
										{t('YES')}
									</button>
								</div>
							)}
						</div>
					</div>
				</ModalContent>
			</Fade>
		</Modal>
	);
};

Ralert.propTypes = {
	msgtypeloadalert: PropTypes.string.isRequired,
	loadalert: PropTypes.bool.isRequired,
	closemodel: PropTypes.func.isRequired,
	confirmbt: PropTypes.func.isRequired,
	minutes: PropTypes.number,
	seconds: PropTypes.number,
	stage: PropTypes.string,
};

const Backdrop = React.forwardRef((props, ref) => {
	const { open, ...other } = props;
	return (
		<Fade in={open}>
			<div ref={ref} {...other} />
		</Fade>
	);
});

const Modal = styled(BaseModal)`
	position: fixed;
	z-index: 1300;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
	z-index: -1;
	position: fixed;
	inset: 0;
	background-color: rgb(0 0 0 / 0.57);
	-webkit-tap-highlight-color: transparent;
`;

const grey = {
	900: '#1C2025',
	50: '#F3F6F9',
	400: '#B0B8C4',
	800: '#303740',
};

const ModalContent = styled('div')(
	({ theme }) => css`
		text-align: center;
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 8px;
		overflow: hidden;
		background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
		border-radius: 20px;
		border: 0px solid transparent;
		outline: none;
		box-shadow: 0 4px 12px
			${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
		padding: 0px;
		color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};
	`,
);
